import styled from "styled-components/macro";
import { Heading4 } from "styles/elements/Headings";
import { Paragraph } from "styles/elements/Texts";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleContainer = styled.div<Props>`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const StyleProgressContainer = styled.div<Props>`
  margin-top: 5px;
  padding-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const StyleBarContainer = styled.div<Props>`
  max-width: 150px;
`;

export const StyleParagraph = styled(Paragraph)<Props>`
color: ${(props: Props) => props.theme.palette.neutral._80};
font-size: ${(props: Props) => props.theme.font.size._12};
margin-bottom: 10px;
`;

export const StylePercentage = styled(Paragraph)<Props>`
font-size: ${(props: Props) => props.theme.font.size._14};
margin-bottom: 0;
width: 35px;
margin-left: 20px;
`;

export const StyleTitle = styled(Heading4)<Props>`
margin-bottom: 0;
font-size: ${(props: Props) => props.theme.font.size._14};
`;

export const StyleSubContainer = styled.div`
display: flex;
flex-direction: row;
button {
  margin-left: 112px;
}
`;
